// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchAlertBanner_root__T16Im","content":"SearchAlertBanner_content__ALp88","button":"SearchAlertBanner_button__d_QBp","media":"SearchAlertBanner_media__w_AHi"};